import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
// Universal Styles
import './Assets/Css/Styles.scss'

import LayoutComponent from "./Defaults/Layout";
import HomeComponent from "./Components/Home/Home";
import Disclaimer from "./Defaults/Footer/Disclaimer/Disclaimer";
import PrivacyPolicy from "./Defaults/Footer/PrivacyPolicy/PrivacyPolicy";
import BrockerNorms from "./Defaults/Footer/BrokerNorms/BrockerNorms";
import PolicyProcedure from "./Defaults/Footer/PolicyProcedures/PolicyProcedure";
import ArbitrationRules from "./Defaults/Footer/ArbitrationRules/ArbitrationRules";
import DoDonts from "./Defaults/Footer/DoDonts/DoDonts";
import Downloads from "./Defaults/Footer/Downloads/Downloads";
import InvestorGrievance from "./Defaults/Footer/InvestorGrievance/InvestorGrievance";
import Contact from "./Components/Contacts/Contact";
import ErrorPage from "./Defaults/NoPage/NoPage";
import OnboardingProcess from "./Components/Home/OnboardingProcess/OnboardingProcess";
import Ticket from "./Components/Ticket/Ticket";
import Sitemap from "./Defaults/Footer/Sitemap/Sitemap";
export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LayoutComponent />}>
          <Route index element={<HomeComponent />} />
          <Route path="contact" element={<Contact />} />
          <Route path="disclaimer" element={<Disclaimer />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="broker-norms" element={<BrockerNorms />} />
          <Route path="policy-procedure" element={<PolicyProcedure />} />
          <Route path="nse-arbitration-rules" element={<ArbitrationRules />} />
          <Route path="do-dont" element={<DoDonts />} />
          <Route path="download" element={<Downloads />} />
          <Route path="investor-grievance" element={<InvestorGrievance />} />
          <Route path="step-by-step" element={<OnboardingProcess />} />
          <Route path="ticket" element={<Ticket />} />
          <Route path="sitemap" element={<Sitemap />} />
          <Route path="*" element={<ErrorPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
